import { useSyncExternalStore } from "react";

const abfrage = window.matchMedia("(max-width: 767px)");

function abonnieren(f: () => void): () => void {
  abfrage.addEventListener("change", f);
  return () => abfrage.removeEventListener("change", f);
}

/** Wahr unter 768 px, also im Handy-Aufbau mit Schublade und Blatt. */
export function useSchmal(): boolean {
  return useSyncExternalStore(abonnieren, () => abfrage.matches);
}
